import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import server from 'server/serverController2';
import { ErrorStateActions } from 'store/actionCreators';
import CenterModal from 'components/presenters/modal/CenterModal';

export default function TooManyReqModal() {
	const errState = useSelector((state) => {  
		return state.errorStateInfo;
	})
	let visible = (errState?.tooManyReqTriggered === true) ? true : false;


	return (<div>
		<CenterModal 
			zIndex={9999} 
			modalVisible={visible}
			dataList={{
				description:"일시적인 장애가 발생하였어요.\n잠시 후 다시 시도해주세요."
			}} 
			onComplete={()=>{
				ErrorStateActions.setTooManyReqErr({tooManyReqTriggered:false});
			}}/>
	</div>);
}
